<template>
  <report-section title="呼吸相关微觉醒" style="position: relative">
    <template v-slot:content>
      <div class="micro-arousal">
        <el-table :data="tableData" border style="width: 100%">
          <!-- 第一列：名称 -->
          <el-table-column prop="name" label="" width="180" align="center" />
          
          <!-- REM列 -->
          <el-table-column prop="rem" label="REM" align="center" />
          
          <!-- NREM列 -->
          <el-table-column prop="nrem" label="NREM" align="center" />
          
          <!-- 觉醒列 -->
          <el-table-column prop="awake" label="觉醒" align="center" />
        </el-table>
      </div>
    </template>
  </report-section>
</template>

<script>
import ReportSection from "@c/report-detail/single-blood-oxygen-report/common/report-section.vue";

export default {
  components: {
    ReportSection,
  },
  props: {
    model: Object,
  },
  computed: {
    tableData() {
      return this.model?.microArousalData || [];
    }
  }
};
</script>

<style lang="scss" scoped>
.micro-arousal {
  width: 100%;
  box-sizing: border-box;
  padding: rem(20) rem(20);
  
  ::v-deep .el-table {
    font-size: rem(14);
    
    th {
      background-color: #f5f7fa;
      font-weight: bold;
      padding: rem(8) 0;
    }
    
    td {
      padding: rem(10) 0;
    }
    
    .cell {
      padding: rem(4) rem(8);
      line-height: 1.5;
    }

    // 第一列内容左对齐
    .el-table__body tr td:first-child .cell {
      text-align: left;
      padding-left: rem(20);
    }
  }
}
</style>